module.exports = __webpack_public_path__ + "static/ses-b434b8c9a460307d86be33d87b6fafca.gif";